__turbopack_context__.v({
  "notindrawer": "StickyBottomButtonWrapper-module-scss-module__H3fxva__notindrawer",
  "wrapper": "StickyBottomButtonWrapper-module-scss-module__H3fxva__wrapper",
});
